export default __webpack_public_path__ + "static/media/excel.a40ba2b2.svg";